import React from 'react';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import moment from 'moment';

class LogsForm extends React.Component {

    onSubmit(e) {
        e.preventDefault();

        const date_el = document.getElementById('date');
        const operation_el = document.getElementById('operation');
        const context_el = document.getElementById('context');
        const type_el = document.getElementById('type');
        const message_el = document.getElementById('message');

        const date = (date_el.value) ? moment(date_el.value) : moment();

        const filter = {
            date: {
                $gte: date.format('YYYY-MM-DD 00:00:00-03'),
                $lte: date.add(1, 'day').format('YYYY-MM-DD 00:00:00-03')
            },

            operation: operation_el.value || { $in: ['INSERT', 'UPDATE', 'DELETE'] },
            tags: (context_el.value) ? { $contains: context_el.value } : undefined,
            type: type_el.value || { $in: ['INFO', 'WARNING', 'ERROR'] },
            message: (message_el.value) ? { $iLike: `%${message_el.value}%` } : undefined
        };

        this.props.onSubmit(filter);
    }

    render() {
        return (
            <Paper>
                <form onSubmit={this.onSubmit.bind(this)}>
                    <div className="form-item">
                        <label>Data:</label>
                        <input defaultValue={moment().format('YYYY-MM-DD')} type="date" id="date" />
                    </div>

                    <div className="form-item">
                        <label>Operação:</label>
                        <select id="operation">
                            <option value="">Todas</option>
                            <option value="INSERT">Criação</option>
                            <option value="UPDATE">Atualização</option>
                            <option value="DELETE">Remoção</option>
                        </select>
                    </div>

                    <div className="form-item">
                        <label>Contexto:</label>
                        <select id="context">
                            <option value="">Todos</option>
                            <option value="users">Usuários</option>
                            <option value="customers">Clientes</option>
                            <option value="vehicles">Veículos</option>
                            <option value="vehicle_contracts">Contratos de veículo</option>
                            <option value="vehicle_types">Tipos de veículos</option>
                            <option value="deliveries">Entregas</option>
                            <option value="delivery_documents">Documentos de Entrega</option>
                            <option value="delivery_types">Tipos de rota</option>
                        </select>
                    </div>

                    <div className="form-item">
                        <label>Tipo:</label>
                        <select id="type">
                            <option value="">Todos</option>
                            <option value="INFO">Informação</option>
                            <option value="WARNING">Alerta</option>
                            <option value="ERROR">Erro</option>
                        </select>
                    </div>

                    <div className="form-item">
                        <label>Messagem contém:</label>
                        <input type="text" id="message" />
                    </div>

                    <div className="form-item">
                        <div></div>
                        <Button raised color="primary" type="submit">Consultar</Button>
                    </div>
                </form>
            </Paper>
        );
    }

}

export default LogsForm;



// WEBPACK FOOTER //
// ./src/components/Logs/Form.js